<template>
<div class="video-demo">
    <video class="video-win" ref="videoRef" preload @timeupdate="timeUpdate" src="https://cdn-open.cigoadmin.com/xingbo/jiangnanli-test1.mp4"></video>
    <img class="play-btn" :class="{'show': showPlayBtnFlag}" @click.stop="startPlay" src="https://cdn-open.cigoadmin.com/icon/video-playBtn.png" />
    <div class="show-code-btn" :class="{'show': showShowBtnFlag}" @click.stop="()=>{showCodeFlag = true;}">点击揭晓</div>
    <img class="mp-code" :class="{'show': showCodeFlag}" src="https://cdn-open.cigoadmin.com/xingbo/mp-jiangnanli.png" />
</div>
</template>

<script lang="ts">
import {
    defineComponent,
    onMounted,
    ref
} from "vue";

export default defineComponent({
    name: "VideoTest",
    setup(props, ctx) {
        let videoRef: any = ref(null);
        let showPlayBtnFlag = ref(true);
        const startPlay = () => {
            showPlayBtnFlag.value = false;
            videoRef.value.play();
        };

        let showShowBtnFlag = ref(false);
        let showCodeFlag = ref(false);
        let layerOpenFlag = ref(false);
        const timeUpdate = (event: any) => {
            let timeCurr = event.srcElement.currentTime;

            if (timeCurr > 3.6 && !layerOpenFlag.value) {
                layerOpenFlag.value = true;

                showShowBtnFlag.value = true;
            }
        };

        return {
            videoRef,
            showPlayBtnFlag,
            showShowBtnFlag,
            showCodeFlag,
            startPlay,
            timeUpdate
        };
    }
});
</script>

<style lang="scss">
.video-demo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: relative;

    .video-win {
        width: 100%;
        height: 100%;
    }

    .play-btn {
        display: none;
        position: absolute;
        width: 80px;
        height: 80px;
        -webkit-animation: playBTN 1s infinite linear;
        animation: playBTN 1s infinite linear;
    }

    .play-btn.show {
        display: flex;
    }

    .show-code-btn {
        display: none;
        position: absolute;
        padding: 10px 15px;
        font-size: 24px;
        border: 1px solid #666;
        color: #666;
        border-radius: 5px;
        -webkit-animation: playBTN 1s infinite linear;
        animation: playBTN 1s infinite linear;
    }

    .show-code-btn.show {
        display: flex;
    }

    .mp-code {
        display: none;
        position: absolute;
        width: 100%;
        height: 100%;
    }

    .mp-code.show {
        display: flex;
    }

    @-webkit-keyframes playBTN {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }

        50% {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }

    @keyframes playBTN {
        0% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }

        50% {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }
}
</style>
